import { useTranslation } from 'react-i18next'
import { useAuth } from '../context/AuthContext'
import './MatchModal.css'

const MatchModal = ({ matchedProfile, onClose, onStartChatting }) => {
  const { t } = useTranslation()
  const { profile: currentProfile } = useAuth()
  
  if (!matchedProfile) return null

  return (
    <div className="match-modal-overlay" onClick={onClose}>
      <div className="match-modal" onClick={(e) => e.stopPropagation()}>
        <div className="match-photos">
          <div className="match-photo-left">
            {matchedProfile.photos && matchedProfile.photos[0] ? (
              <img src={matchedProfile.photos[0]} alt={matchedProfile.name} />
            ) : (
              <div className="photo-placeholder">{matchedProfile.name?.[0] || '?'}</div>
            )}
          </div>
          <div className="match-photo-right">
            {currentProfile?.photos && currentProfile.photos[0] ? (
              <img src={currentProfile.photos[0]} alt={currentProfile.name || 'You'} />
            ) : (
              <div className="photo-placeholder">{currentProfile?.name?.[0] || 'You'}</div>
            )}
          </div>
        </div>
        
        <h1 className="match-title">{t('matchModal.itsAMatch')}</h1>
        <p className="match-description">
          {t('matchModal.youLikedEachOther')}
        </p>
        
        <div className="match-actions">
          <button className="match-btn-primary" onClick={onStartChatting}>
            {t('matchModal.startChatting')}
          </button>
          <button className="match-btn-secondary" onClick={onClose}>
            {t('matchModal.maybeLater')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default MatchModal
